import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Resource } from 'src/app/models/resource.model';

@Component({
  selector: 'my-rep-resource-card',
  templateUrl: './resource-card.component.html',
  styleUrls: ['./resource-card.component.scss'],
})
export class ResourceCardComponent {
  @Input() resource: Resource;
  @Input() pinkBg: boolean;
  @Output() edit = new EventEmitter<MouseEvent>();
  @Output() delete = new EventEmitter<MouseEvent>();

  public onEdit(event: MouseEvent): void {
    this.edit.emit(event);
  }

  public onDelete(event: MouseEvent): void {
    this.delete.emit(event);
  }
}
